<!-- 分页组件 -->
<template>
    <div id="pagation" class="pagation">
        <template v-if="noLiSurround && showCount">
            <!-- 共5条 -->
            <div class="page_every">共&nbsp;{{this.count}}&nbsp;条</div>
        </template>
        <template v-else-if="!noLiSurround">
            <span class="page_count">{{this.count}}条 {{pageNum}}/{{pageCount}}页</span>
            <paginate 
                :noLiSurround="noLiSurround" 
                :page-count="pageCount" 
                :margin-pages="2" 
                :page-range="5"
                :click-handler="clickCallback" 
                :container-class="'pagination'" 
                :page-class="'page-item'"
                :prev-class="'prev-item'" 
                :next-class="'next-item'" 
                :firstLastButton="true" 
                :hidePrevNext="true"
                prevText="&lt;&lt;"
                nextText="&gt;&gt;"
                firstButtonText="首页"
                lastButtonText="末页">
            </paginate>
            <!-- <input type="text" v-if="pageCount != 1" v-model="pageNum" class="goinput">
            <span class="gopage" v-if="pageCount != 1" @click="clickCallback(pageNum)">跳转</span> -->
        </template>
    </div>
</template>
   
<script>
import Paginate from 'vuejs-paginate'
export default {
    data() {
        return {
            //noLiSurround: false,//当为true时证明总数不满一页
            firstButton: true,//是否显示首页按钮
            lastButton: false,//是否显示最后一页按钮
            // pageNum: 1,//跳转哪一页,当前页
            // count: 200,
            // pageCount: 1,
            // pageSize: 20
        };
    },
    props: {
        pageSize: {
            type: Number,
            default: 10
        },
        pageNum: Number,
        count: Number,
        showCount: {
            type: Boolean,
            default: true
        },
    },
    components: {
        Paginate
    },
    computed:{
        pageCount(){
            return Math.ceil(this.count / this.pageSize)
        },
        noLiSurround(){
            return this.count < this.pageSize ? true : false
        }
    },
    created() {
        // // 计算当前页数
        // this.pageCount = 
        // // 如果count小于pageSize则不显示页码
        // console.log('in')
        // console.log(this.count)
        // console.log(this.pageSize)
        // if () {
        //      = true
        // }
    },
    methods: {
        clickCallback(pageNum) {
            console.log(pageNum)
            //this.pageNum = pageNum
            this.$emit('chagePage',pageNum)
        },
    },
};
</script>
<style lang='less' scope>
#pagation {
    width: 100%;
    padding: 60px 10px;
    text-align: center;

}

.page_every {
    font-size: 16px;
    color: #333;
}

.page_count {
    display: inline-block;
    vertical-align: middle;
    margin: 6px 5px 0 0;
}

.goinput {
    display: inline-block;
    height: 26px;
    line-height: 26px\9;
    width: 40px;
    text-align: center;
    border: 1px solid #d9d9d9;
    margin: 7px 5px 0 0;
    vertical-align: middle;
    color: #2562bd;
}

.gopage {
    display: inline-block;
    *display: inline;
    height: 26px;
    line-height: 26px;
    zoom: 1;
    padding: 0 10px;
    border: 1px solid #d9d9d9;
    color: #2562bd;
    vertical-align: middle;
    margin: 6px 5px 0 0;
    background: #fff;
    cursor: pointer;
}

.pagination {
    display: inline-block;
    font-size: 0;
    padding: 0;

    li {

        &.disabled {
            display: none;
        }

        display: inline-block;
        *display: inline;
        margin: 0 3px;
        height: 32px;
        line-height: 30px;
        zoom: 1;
        border: 1px solid #004098;
        border-radius: 2px;
        font-size:14px;
        color: #666;
        vertical-align: middle;
        background: #fff;

        &:hover {
            opacity: .9;
            background-color: #E3ECFD;
        }

        a {
            display: block;
            padding: 0 10px;
            color: #666;
        }

        &.active {
            background-color: #004098;
            color: #fff;
            cursor: pointer;

            a {
                color: #fff;
            }
        }
    }
}
</style>